var _g, _defs, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "swap-top-arrow",
    strokeWidth: 53,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    className: "swap-arrow-line",
    x1: 155,
    y1: 325,
    x2: 615,
    y2: 325
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615,
    y1: 325,
    x2: 615,
    y2: 325,
    markerEnd: "url(#SvgMarkerRight)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    markerWidth: 6,
    markerHeight: 6,
    refX: 3,
    refY: 3,
    viewBox: "0 0 6 6",
    orient: "auto",
    id: "SvgMarkerRight"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "0,3 2,1.5 0,0",
    fill: "none",
    strokeWidth: 1,
    strokeLinecap: "round",
    transform: "matrix(1,0,0,1,1,1.5)",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "swap-bottom-arrow",
    strokeWidth: 53,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    className: "swap-arrow-line",
    x1: 615,
    y1: 550,
    x2: 155,
    y2: 550
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156,
    y1: 550,
    x2: 155,
    y2: 550,
    markerEnd: "url(#SvgMarkerRight)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.bc8c51a5726c018c53d314a2ac8660a6.svg";
export { ForwardRef as ReactComponent };